webpackJsonp([35783957827783],{

/***/ 107:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"landingHeaderSlant":"src-assets-css----landing-module---landingHeaderSlant---1gt5b","landingLogo":"src-assets-css----landing-module---landingLogo---1CIP2","bgBlueGrad":"src-assets-css----landing-module---bgBlueGrad---2nkGO","bgPurpleGrad":"src-assets-css----landing-module---bgPurpleGrad---3gFxb"};

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetStartedButton = function (_React$Component) {
	    _inherits(GetStartedButton, _React$Component);
	
	    function GetStartedButton() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, GetStartedButton);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.saveAndProceed = function (value, link) {
	
	            if (_this.props.index) {
	
	                var valueLower = value.toLowerCase();
	
	                localStorage.setItem('Generation', valueLower);
	                (0, _gatsbyLink.push)(link);
	            } else {
	
	                localStorage.setItem('About', value);
	                (0, _gatsbyLink.push)(link);
	            }
	        }, _this._renderSubHeading = function () {
	
	            if (!_this.props.index) {
	
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'block text-navy-dark' },
	                    'About'
	                );
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    GetStartedButton.prototype.render = function render() {
	        var _this2 = this;
	
	        var buttonTextColour = void 0;
	        var borderColour = void 0;
	        var spacing = void 0;
	
	        if (this.props.theme === 'orange') {
	            buttonTextColour = 'text-orange';
	            borderColour = 'border-orange';
	        } else {
	            buttonTextColour = 'text-blue';
	            borderColour = 'border-blue';
	        }
	
	        if (this.props.left) {
	            spacing = 'mr-8';
	        } else {
	            spacing = 'ml-8';
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { type: 'button', onClick: function onClick() {
	                    return _this2.saveAndProceed(_this2.props.text, _this2.props.link);
	                }, title: 'Start About Me', className: 'w-1/2 bg-white border-4 border-blue-transparent rounded-lg no-underline overflow-hidden hover:' + borderColour + ' ' + spacing },
	            _react2.default.createElement(
	                'figure',
	                { className: 'flex items-center justify-between' },
	                _react2.default.createElement(
	                    'figcaption',
	                    { className: 'p-8 mr-8 text-center text-5xl leading-tight w-1/2' },
	                    this._renderSubHeading(),
	                    _react2.default.createElement(
	                        'span',
	                        { className: !this.props.index ? 'block ' + buttonTextColour : 'text-navy-dark' },
	                        this.props.text
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'w-1/2' },
	                    _react2.default.createElement('img', { src: this.props.img, className: 'block m-auto' })
	                )
	            )
	        );
	    };
	
	    return GetStartedButton;
	}(_react2.default.Component);
	
	exports.default = GetStartedButton;
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _nigalaLogo = __webpack_require__(188);
	
	var _nigalaLogo2 = _interopRequireDefault(_nigalaLogo);
	
	var _landingModule = __webpack_require__(107);
	
	var _landingModule2 = _interopRequireDefault(_landingModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LandingHeader = function (_React$Component) {
	    _inherits(LandingHeader, _React$Component);
	
	    function LandingHeader(props) {
	        _classCallCheck(this, LandingHeader);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    LandingHeader.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'header',
	            { className: _landingModule2.default.landingHeader + ' [ relative z-20 ]' },
	            _react2.default.createElement(
	                'div',
	                { className: 'bg-white pt-8' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/' },
	                    _react2.default.createElement('img', { src: _nigalaLogo2.default, className: _landingModule2.default.landingLogo, alt: 'Nigala Logo' })
	                )
	            ),
	            _react2.default.createElement('span', { className: _landingModule2.default.landingHeaderSlant + ' [ block h-24 ]' })
	        );
	    };
	
	    return LandingHeader;
	}(_react2.default.Component);
	
	exports.default = LandingHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LandingHeader = __webpack_require__(192);
	
	var _LandingHeader2 = _interopRequireDefault(_LandingHeader);
	
	var _GetStartedButton = __webpack_require__(191);
	
	var _GetStartedButton2 = _interopRequireDefault(_GetStartedButton);
	
	var _landingModule = __webpack_require__(107);
	
	var _landingModule2 = _interopRequireDefault(_landingModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Homepage = function (_React$Component) {
	    _inherits(Homepage, _React$Component);
	
	    function Homepage(props) {
	        _classCallCheck(this, Homepage);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    Homepage.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'div',
	            { className: [_landingModule2.default.bgBlueGrad] + ' [ flex flex-col h-screen overflow-y-scroll  ]' },
	            _react2.default.createElement(_LandingHeader2.default, null),
	            _react2.default.createElement(
	                'div',
	                { className: 'landing [ relative ][ flex flex-1 flex-wrap items-center justify-center ][ p-8 mt-10-sh ]' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'relative z-10 p-8' },
	                    _react2.default.createElement(
	                        'nav',
	                        { className: 'flex items-center justify-center w-full' },
	                        _react2.default.createElement(_GetStartedButton2.default, {
	                            index: true,
	                            text: 'Young',
	                            theme: 'orange',
	                            link: '/please-select',
	                            img: '/assets/images/younger/about-me-younger.png',
	                            left: true
	                        }),
	                        _react2.default.createElement(_GetStartedButton2.default, {
	                            index: true,
	                            text: 'Old',
	                            theme: 'blue',
	                            img: '/assets/images/older/about-me-older.png',
	                            link: '/please-select',
	                            left: false
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'w-full text-center text-4xl leading-normal mt-8 pt-8' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'block text-white' },
	                            'Our job is to keep you safe.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'block text-white' },
	                            'So sometimes we have to share what you tell us with other people.'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Homepage;
	}(_react2.default.Component);
	
	exports.default = Homepage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ecff87f60186abd18756.js